<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/labelAdmin">标签管理</BreadcrumbItem>
            <BreadcrumbItem>新建标签</BreadcrumbItem>
        </Breadcrumb>
        <Card>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120" label-position="left" style="margin-left:10px">
                <FormItem label="规则名称" prop="name">
                    <Input v-model="formValidate.name" style="width:300px"></Input>
                </FormItem>
                <FormItem label="用户标签字段" prop="key">
                    <Input v-model="formValidate.key" style="width:300px"></Input>
                </FormItem>
                <FormItem label="规则类型" prop="condition_type">
                    <Select v-model="formValidate.condition_type" style="width:300px">
                        <Option v-for="type in condition_types" :value="type.value" :key="type.value">{{type.label}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="比较值" prop="condition_value">
                    <Input v-model="formValidate.condition_value" style="width:300px"></Input>
                </FormItem>
                <FormItem label="是否激活" prop="active_flag">
                    <RadioGroup v-model="formValidate.active_flag">
                        <Radio label="1">是</Radio>
                        <Radio label="0">否</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
                </FormItem>
            </Form>
        </Card>
    </div>
</template>
<script>
import{createLabel}from "@/request/api"
import Cookies from 'js-cookie';
export default {
  name: 'createLabel',
  meta:{},
  data() {
    return {
        condition_types: [
            {
                label: '包含',
                value: '1'
            },
            {
                label: '不包含',
                value: '2'
            },
            {
                label: '小于',
                value: '3'
            },
            {
                label: '小于等于',
                value: '4'
            },
            {
                label: '等于',
                value: '5'
            },
            {
                label: '大于等于',
                value: '6'
            },
            {
                label: '大于',
                value: '7'
            },
        ],
        formValidate:{
            name: '',
            key: '',
            condition_type: '1',
            condition_value: '',
            active_flag: '0',
        },
        ruleValidate: {
                name: [
                    { required: true, message: 'cannot be empty', trigger: 'blur' }
                ],
                key: [
                    { required: true, message: 'cannot be empty', trigger: 'blur' }
                ],
                condition_type: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ],
                condition_value: [
                    { required: true, message: 'cannot be empty', trigger: 'blur' }
                ],
                active_flag: [
                    { required: true, message: 'Please select one', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        handleSubmit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    createLabel(
                        {
                            name: this.formValidate.name,
                            key: this.formValidate.key,
                            condition_type: this.formValidate.condition_type - 0,
                            condition_value: this.formValidate.condition_value,
                            active_flag: this.formValidate.active_flag - 0,
                        }
                    ).then(res=>{
                        if(res.data.code==200){
                            this.$Message.success('Success!');
                            this.$router.back(-1);
                        }else{
                            this.$Message.error(res.data.msg);
                        }
                    })
                } else {
                    this.$Message.error('Fail!');
                }
            })
        }
    },
    created() {
        Cookies.set('active_name', '6')
    },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Label/LabelCreate.vue